export default __webpack_public_path__ + "static/media/airdockz-wht-banner-2.de2e5b6a.jpg";